import Icon from '../../components/Icon.vue'

Icon.register({"regular/circle":{"width":512,"height":512,"paths":[{"d":"M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM256 456C145.5 456 56 366.5 56 256S145.5 56 256 56 456 145.5 456 256 366.5 456 256 456z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/circle.js
// module id = ZxDr
// module chunks = 0